module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./receipt-refund-details.ts"));
	}, "forms/receipt-refund-details/receipt-refund-details");
}